import { useEffect, useRef, useState } from 'react';
import styled, { keyframes, css } from 'styled-components';

const FadeInUp = ({
  children,
  threshold = 0.3,
  delay = 0,
  addedStyle,
  positionValue = 0,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), delay);
        }
      },
      { threshold },
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, [delay, threshold]);

  return (
    <FadeInWrapper
      ref={elementRef}
      isVisible={isVisible}
      addedStyle={addedStyle}
    >
      {children}
    </FadeInWrapper>
  );
};

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const FadeInWrapper = styled.div`
  ${({ isVisible }) =>
    isVisible &&
    css`
      animation: ${fadeInUp} 0.8s ease-out forwards;
    `}

  ${({ addedStyle }) =>
    addedStyle &&
    css`
      ${addedStyle}
    `}
`;

export default FadeInUp;
